import { Config } from '@flowwai-frontend/bps-officer-web/env-config'
import { ClientType } from '@flowwai-frontend/bps-officer-web/navbar-base'

export const HOME = 'HOME'

export const ANALYTICS = 'ANALYTICS'

export const DASHBOARDS = 'DASHBOARDS'

export const PINNED = 'PINNED'

export const GENERATE_SCRUTINY = 'GENERATE_SCRUTINY'

export const CALLS = 'CALLS'

export const CONTACTS = 'CONTACTS'

export const PIPELINES = 'PIPELINES'

export const TEMPLATES = 'TEMPLATES'

export const STAGE_BOARDS = 'STAGE_BOARDS'

export const SMART_BOARDS = 'SMART_BOARDS'

export const NOTIFICATIONS = 'NOTIFICATIONS'

export const ANALYTICS_CO_PILOT = 'ANALYTICS_CO_PILOT'

export const GIS = 'GIS'

export const USERS = 'USERS'

export const USERS_LOGS = 'USERS_LOGS'

export const NEW_USER_NEW_OFFICER = 'NEW_USER_NEW_OFFICER'

export const LTP_USERS = 'LTP_USERS'

export const LTP_USERS_LOGS = 'LTP_USERS_LOGS'

export const ON_HOLD_TDR_CERTIFICATE = 'ON_HOLD_TDR_CERTIFICATE'

export const CERTIFICATES_LOGS = 'CERTIFICATES_LOGS'

export const RELEASE_CERTIFICATE = 'RELEASE_CERTIFICATE'

export const TDR_MANAGEMENT = 'TDR_MANAGEMENT'

export const LEGACY_APPLICATIONS = 'LEGACY_APPLICATIONS'

export const TDR_LEGACY_APPLICATIONS = 'TDR_LEGACY_APPLICATIONS'

export const SEARCH_AND_MONITORING = 'SEARCH_AND_MONITORING'

export const APPLICATIONS_ASSIGNED_BY_FRIEND = 'APPLICATIONS_ASSIGNED_BY_FRIEND'

export const PMU_APPLICATION_MANAGEMENT = 'PMU_APPLICATION_MANAGEMENT'

export const PMU_APPLICATIONS = 'PMU_APPLICATIONS'

export const TASK_SHORTFALL = 'TASK_SHORTFALL'

export const APPLICATION_MANAGEMENT_LOGS = 'APPLICATION_MANAGEMENT_LOGS'

export const adminApplicationNavItems = {
   profileSettings: 'PROFILE_SETTINGS',
   billing: 'BILLING',
   integrations: 'INTEGRATIONS',
   parameterStore: 'PARAMETER_STORE',
   portals: 'PORTALS'
}

export const adminUserSectionNavItems = {
   usersAnsPermissions: 'USERS_AND_PERMISSIONS',
   ROLES: 'ROLES',
   USERS: 'USERS',
   GROUPS: 'GROUPS',
   PROPERTIES: 'PROPERTIES',
   UPLOAD_USERS: 'UPLOAD_USERS',
   EXPORT_USERS: 'EXPORT_USERS',
   CLOCK_IN_CONFIG: 'CLOCK_IN_CONFIG'
}

export const adminContactSectionNavItems = {
   contactSettings: 'CONTACT_SETTINGS',
   contactFields: 'CONTACT_FIELDS',
   contactLogs: 'CONTACT_LOGS',
   uploadContacts: 'UPLOAD_CONTACTS',
   exportContacts: 'EXPORT_CONTACTS',
   configurations: 'CONFIGURATIONS'
}

export const adminPipelinesSectionNavItems = {
   analyticsBuilder: 'ANALYTICS_BUILDER',
   pipelineSettings: 'PIPELINE_SETTINGS',
   recordTemplate: 'RECORD_TEMPLATE',
   leadTemplate: 'LEAD_TEMPLATE',
   uploadPipelineItems: 'UPLOAD_PIPELINE_ITEMS',
   exportLeads: 'EXPORT_LEADS',
   dealTemplate: 'DEAL_TEMPLATE',
   uploadDeals: 'UPLOAD_DEALS',
   exportDeals: 'EXPORT_DEALS',
   activities: 'ACTIVITIES',
   activityTemplates: 'ACTIVITY_TEMPLATES',
   uploadActivities: 'UPLOAD_ACTIVITIES',
   activityLogs: 'ACTIVITY_LOGS',
   taskTemplates: 'TASK_TEMPLATES',
   sharableResources: 'SHARABLE_RESOURCES',
   downloads: 'DOWNLOADS',
   pipelinePermissions: 'PIPELINE_PERMISSIONS',
   leadDistribution: 'LEAD_DISTRIBUTION',
   distributionRules: 'DISTRIBUTION_RULES',
   agentAllocationGroups: 'AGENT_ALLOCATION_GROUPS',
   distributionLogs: 'DISTRIBUTION_LOGS',
   workflows: 'WORKFLOWS',
   allWorkflows: 'ALL_WORKFLOWS',
   workflowLogs: 'WORKFLOW_LOGS',
   relations: 'RELATIONS',
   pipelineEvents: 'PIPELINE_EVENTS',
   documentTemplates: 'DOCUMENT_TEMPLATES',
   scoringConfig: 'SCORING_CONFIG',
   scoringRules: 'SCORING_RULES',
   scoringReCalculationLogs: 'SCORING_RECALCULATION_LOGS'
}

export const adminTemplatesSectionNavItems = {
   analyticsBuilder: 'ANALYTICS_BUILDER',
   settings: 'SETTINGS',
   recordTemplate: 'RECORD_TEMPLATE',
   leadTemplate: 'LEAD_TEMPLATE',
   uploadPipelineItems: 'UPLOAD_PIPELINE_ITEMS',
   exportLeads: 'EXPORT_LEADS',
   dealTemplate: 'DEAL_TEMPLATE',
   uploadDeals: 'UPLOAD_DEALS',
   exportDeals: 'EXPORT_DEALS',
   activities: 'ACTIVITIES',
   activityTemplates: 'ACTIVITY_TEMPLATES',
   uploadActivities: 'UPLOAD_ACTIVITIES',
   activityLogs: 'ACTIVITY_LOGS',
   taskTemplates: 'TASK_TEMPLATES',
   sharableResources: 'SHARABLE_RESOURCES',
   downloads: 'DOWNLOADS',
   pipelinePermissions: 'PIPELINE_PERMISSIONS',
   leadDistribution: 'LEAD_DISTRIBUTION',
   distributionRules: 'DISTRIBUTION_RULES',
   agentAllocationGroups: 'AGENT_ALLOCATION_GROUPS',
   distributionLogs: 'DISTRIBUTION_LOGS',
   workflows: 'WORKFLOWS',
   allWorkflows: 'ALL_WORKFLOWS',
   workflowLogs: 'WORKFLOW_LOGS',
   relations: 'RELATIONS',
   pipelineEvents: 'PIPELINE_EVENTS',
   documentTemplates: 'DOCUMENT_TEMPLATES',
   scoringConfig: 'SCORING_CONFIG',
   scoringRules: 'SCORING_RULES',
   scoringReCalculationLogs: 'SCORING_RECALCULATION_LOGS'
}

export const nonExactMatchAdminPipelineNavItemIds = [
   adminPipelinesSectionNavItems.analyticsBuilder
]

export const navActions = {
   add: 'ADD',
   rename: 'RENAME',
   editFIlters: 'EDIT_FILTERS',
   share: 'SHARE',
   delete: 'DELETE'
}

export const SCROLL_DISPLAY_TIME = 300

export const APP_CLIENT_ENUM: ClientType = Config.APP_CLIENT_ENUM
